import { diagEntries, diagSubscribe } from './diagLog';

const KEY = 'hc_auto_diagnostics';
export function autoDiagnosticsEnabled(): boolean {
  try { return localStorage.getItem(KEY) === 'true'; } catch { return false; }
}
export function setAutoDiagnosticsEnabled(enabled: boolean): void {
  try { localStorage.setItem(KEY, String(enabled)); } catch { /* При недоступном хранилище сохраняем безопасное значение «выключено». */ }
}

/** Только новые ошибки после согласия; без истории, адресов, тел, токенов и текстов исключений. */
export function startAutoDiagnostics(send: (text: string) => Promise<unknown>): () => void {
  let last = diagEntries()[diagEntries().length - 1];
  let busy = false;
  let stopped = false;
  let nextAllowed = 0;
  const unsubscribe = diagSubscribe(() => {
    const entry = diagEntries()[diagEntries().length - 1];
    if (!entry || entry === last) return;
    last = entry;
    if (!autoDiagnosticsEnabled() || busy || Date.now() < nextAllowed || entry.kind !== 'api' ||
      !(entry.status === 0 || (entry.status ?? 0) >= 500 || entry.what === 'response:parse')) return;
    busy = true;
    nextAllowed = Date.now() + 60_000;
    const text = '🐛 CRASH [web]\n' + JSON.stringify({ time: entry.t, status: entry.status, requestId: entry.rid, durationMs: entry.ms });
    // Ошибка самой отправки не порождает новый отчёт; автоматических повторов нет.
    void Promise.resolve().then(() => !stopped && autoDiagnosticsEnabled() ? send(text) : undefined).catch(() => {}).finally(() => { busy = false; });
  });
  return () => { stopped = true; unsubscribe(); };
}
